import { useSuspenseQuery } from "@tanstack/react-query"
import { getAvatars } from "./client"

export function useAvatars() {
	return useSuspenseQuery({
		queryKey: ["avatars"],
		queryFn: getAvatars,
		staleTime: 5 * 60_000, // 5 minutes
	})
}
